import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { AppConfigContext } from "./CmdbConfig";
import Spinners from "../../../../app/common-components/Spinner";
import { effciencyApi } from "../../../../app/services/efficiencyApi";
import "../styles.scss";
import { useCommonAlert } from "../../../../app/utilities/helpers";
import CustomModal from "../../../../app/common-components/CustomModal";


const DeleteModal = ({ fetchApiData, getpayload }) => {
  const context = useContext(AppConfigContext);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const {  userName, userRole } = useSelector((state) => state.common.loggedUser);
  const [deleteApplication] = effciencyApi.useDeleteApplicationMutation();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const handleClose = () => {
    context.setState((state) => ({
      ...state,
      deleteModalOpen: false,
    }));
  };

  const handleDelete = async () => {
      await  deleteApplication({ id:context.state.cmdbId,userName }).unwrap(setIsDeleteLoading(true)).then((data) => {
        setIsDeleteLoading(false);
        callCommonAlert("success", "Selected configuration item is deleted successfully");
        hideCommonAlert();
      context.setState((state) => ({
        ...state,
        deleteModalOpen:false,
        loadPage: !state.loadPage,
      }));
      const payload = getpayload();
      fetchApiData(0, 10, payload);
    })
    .catch(error => {
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
      context.setState((state) => ({
        ...state,
        deleteModalOpen:false,
        loadPage: !state.loadPage,
      }));
    });
    const payload = getpayload();
    fetchApiData(0, 10, payload);
  };

  const modalBody = () => (
    <div className="modal-body">
      <h4 className="delete-h">Delete Application</h4>
      {isDeleteLoading ? <Spinners/> : (<div>
      <p>Application cannot be deleted. It will be inactive</p>
      <p>User permission will be revoked</p>
      <div className="btnswrap">
        <button
          className="cancelBtnStyle btn btn-primary"
          data-testid="cancel-delete-btn"
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </button>
        <button
          className="btnStyle btn btn-primary"
          data-testid="confirm-delete-btn"  
          onClick={() => {
            handleDelete();
          }}
        >
          Delete
        </button>
      </div>
      </div>)}
    </div>
  );

  return (
    <CustomModal
      modalOpen={context.state.deleteModalOpen}
      modalHide={handleClose}
      modalBody={modalBody}
    />
  );
};

export default DeleteModal;
